export default function (caseNumber) {
  return {
    name: "Upload Abandonment or Termination Notices",
    pageInfo: {
      text: "Please upload abandonment or termination notice(s). Your request will be added to the case documents.",
      coloring: "grey",
    },
    sections: [
      {
        fields: [
          {
            machine_name: "Abandon_Terminate_Case_Number",
            widget: "text",
            label: "Case Number *",
            maxLength: 100,
            disabled: true,
            value: caseNumber || "",
          },
          {
            isGroup: {
              label: `The filer may enter in a case note or upload a document. At least one is required. 
              If a document is uploaded, the filer <b>must</b> enter in a description for the corresponding document file.`,
              required: true,
              machine_name: "generic_placeholder",

              fields: [
                {
                  machine_name: "case_note",
                  widget: "text_area",
                  label: "Case Note",
                  inputLimit: 4000,
                  rows: 7,
                  validate: [
                    {
                      subsetOfSetRequired: "generic_placeholder",
                      message: "This field is required",
                      needsFieldValues: true,
                      extraData: {
                        numRequired: 1,
                        fieldArray: [
                          "case_note",
                          ["files", "document_description"],
                        ],
                      },
                    },
                  ],
                },
                {
                  machine_name: "fileType",
                  widget: "text",
                  value: "Abandonment or Termination Notice",
                  style: {
                    display: "none",
                  },
                },
                {
                  machine_name: "files",
                  widget: "file_upload",
                  file_upload: { fileType: "Abandon_Terminate_Notice_Upload" },
                  accept_multiple: true,
                  dontShowAsterisk: true,
                  checkFilesAdded: true,
                  documentAuth: "dh",
                },
                {
                  machine_name: "document_description",
                  widget: "text",
                  label: "Document Description(s)",
                  maxLength: 100,
                },
              ],
            },
          },
        ],
      },
    ],
  };
}
